import React from "react";
import { ClientFilterProvider } from "../../hooks/ClientFilterProvider";
import { ClientListTable } from "../../components/client/ClientListTable";

export interface ClientsListProps {
  className?: string;
}

export const ClientsList: React.FC<ClientsListProps> = ({ className }) => {
  return (
    <div>
      <ClientFilterProvider>
        <ClientListTable />
      </ClientFilterProvider>
    </div>
  );
};

export default ClientsList;
